/** Ruta del reproductor para un episodio de un anime. */
export function watchUrl(animeUrl: string, episodeUrl: string): string {
  return `/watch?anime=${encodeURIComponent(animeUrl)}&ep=${encodeURIComponent(episodeUrl)}`;
}
